export enum TestAutomationTools {
  'cucumberjs' = 'cucumberjs',
  'cucumberjvm' = 'cucumberjvm',
  'jest' = 'jest',
  'mocha' = 'mocha',
  'cypress' = 'cypress',
  'webdriverio' = 'webdriverio',
  'extension_chrome_labe' = 'labe-browser-extension',
  'extension_chrome_accessibility_checker' = 'accessibility-checker-browser-extension',
  'extension_firefox' = 'ff-browser-extension',
  'figma' = 'figma',
  'dca_windows' = 'dca_windows',
  'dca_mac' = 'dca_mac',
  'odt_mac' = 'odt_mac',
  'odt2_macos' = 'odt2_macos',
  'odt2_win_x64' = 'odt2_win_x64',
  'odt2_win_arm64' = 'odt2_win_arm64',
  'odt2_deb_x64' = 'odt2_deb_x64',
  'odt2_deb_arm64' = 'odt2_deb_arm64',
  'odt2_rpm_x64' = 'odt2_rpm_x64',
  'odt2_rpm_arm64' = 'odt2_rpm_arm64',
  'leveldocs_word_win_32_user' = 'leveldocs_word_win_32_user',
  'leveldocs_word_win_32_machine' = 'leveldocs_word_win_32_machine',
  'leveldocs_word_win_64_user' = 'leveldocs_word_win_64_user',
  'leveldocs_word_win_64_machine' = 'leveldocs_word_win_64_machine',
  'leveldocs_ppt_win_32_user' = 'leveldocs_ppt_win_32_user',
  'leveldocs_ppt_win_32_machine' = 'leveldocs_ppt_win_32_machine',
  'leveldocs_ppt_win_64_user' = 'leveldocs_ppt_win_64_user',
  'leveldocs_ppt_win_64_machine' = 'leveldocs_ppt_win_64_machine',
  'leveldocs_excel_win_32_user' = 'leveldocs_excel_win_32_user',
  'leveldocs_excel_win_32_machine' = 'leveldocs_excel_win_32_machine',
  'leveldocs_excel_win_64_user' = 'leveldocs_excel_win_64_user',
  'leveldocs_excel_win_64_machine' = 'leveldocs_excel_win_64_machine',
  'mobile_engine_ios_sdk' = 'mobile-engine-ios-sdk',
  'mobile_engine_android_sdk' = 'mobile-engine-android-sdk',
}
